var app = angular.module('leonardo');

var FormPhone = function(AuthDataService, $timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      blur: '&ngBlur',
      focus: '&ngFocus',
      onSubmit: '&',
      label: '@',
      placeholder: '@',
      clearText: '=clearText',
      mask: '=ngMask'
    },
    templateUrl: 'views/templates/form/form-phone.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.country = AuthDataService.authData && AuthDataService.authData.account ? angular.copy(AuthDataService.authData.account.country) : null;

      scope.phoneMask = scope.mask || scope.defaultPhoneMask;

      scope.setMask = function () {
        if (scope.phoneMask) {
          angular.element(element[0]).find('input').mask(scope.phoneMask);
        }
      };

      scope.$watch('value', function (value) {
        scope.ngModelCtrl.$setViewValue(value);
        scope.setMask();
      });

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
      };

      scope.clear = function () {
        if (scope.ngModelCtrl.$viewValue !== '') {
          scope.ngModelCtrl.$setViewValue('');
          scope.value = scope.ngModelCtrl.$viewValue;
          scope.onSubmit();
        }
      };

      element.find('input').bind('keydown keypress', function (event) {
        if (event.keyCode === 13) {
          scope.$apply(function () {
            scope.onSubmit();
          });
          event.preventDefault();
        }
      });

      scope.$watch('mask', function (value) {
        scope.phoneMask = value;
        scope.setMask();
      });

      $timeout(function () {
        scope.setMask();
      }, 0);
    }
  };
};

app.directive('formPhone', ['AuthDataService', '$timeout', FormPhone]);
